var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.mapData.longitude && _vm.mapData.latitude
    ? _c("div", {
        staticClass: "contacts-map",
        class: _setup.isMobile ? "contacts-map--mobile mt-4" : "mt-8",
        attrs: { id: "yandex-map", "data-qa": "contacts-map" },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }